// Share targets for a finished quiz. Facebook and LinkedIn ignore any text we
// pass and build the post from the link's Open Graph tags; the API serves those
// at the share URL, since the SPA's index.html only carries site-wide tags.

export const shareText = (score: number, total: number, quizTitle: string) =>
    `Scored ${score}/${total} on the WEB3PWN ${quizTitle}. Can you beat it?`;

export const xShareUrl = (url: string, text: string) =>
    `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;

export const facebookShareUrl = (url: string) =>
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

export const linkedInShareUrl = (url: string) =>
    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

/** Copies text, falling back to a hidden textarea where the async clipboard API is unavailable. */
export const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        // Denied or insecure context: try the legacy path below.
    }

    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    let copied = false;
    try {
        copied = document.execCommand('copy');
    } catch {
        copied = false;
    }
    document.body.removeChild(el);
    return copied;
};
